import { render, staticRenderFns } from "./LahanGisVerification.backup.vue?vue&type=template&id=0308d4d4"
import script from "./LahanGisVerification.backup.vue?vue&type=script&lang=js"
export * from "./LahanGisVerification.backup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports